@keyframes alertsEnterAnimation {
  from {
    transform: rotateX(90deg);
    opacity: 0;
  }
  to {
    transform: rotateX(0deg);
    opacity: 1;
  }
}

.alertsContainer {
  animation: 500ms ease-in alertsEnterAnimation;
}
